<div class="modal-dialog custom-error-alert review-form modal-content modal-background review-dialog-bg">
  <section class="content-section review-form-sec" id="review-section">
    <article class="page-wrap mar-t-30 row">
      <div class="col-12">
        <span class="form-head">Write a review</span>
      </div>
    </article>
    <hos-success-alert life="2000"></hos-success-alert>
    <article class="page-wrap">
      <form [formGroup]="reviewDtlForm" novalidate>
        <div class="modal-body">
          <div class="user-details" *ngIf="!userDetails">
            <div class="row">
              <div class="col-sm-6 col-xs-6 PL-15 PR-15">
                <div class="form-group required">
                  <label class="review-label control-label">First Name</label>
                  <input
                    class="form-control"
                    maxlength="25"
                    placeholder="Enter First Name"
                    formControlName="firstName"
                    type="text"
                    name="firstName"
                    required
                  />
                  <div class="invalid-field" *ngIf="reviewDtlForm.controls['firstName'].errors?.pattern">
                    <span>First Name is invalid.</span>
                  </div>
                  <div
                    class="invalid-field"
                    *ngIf="reviewDtlForm.controls['firstName'].touched && reviewDtlForm.controls['firstName'].errors?.required"
                  >
                    <span>First name required</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-xs-6 PL-15 PR-15">
                <div class="form-group required">
                  <label class="review-label control-label">Last Name</label>
                  <input
                    class="form-control"
                    maxlength="25"
                    placeholder="Enter Last Name"
                    formControlName="lastName"
                    type="text"
                    name="lastName"
                    required
                  />
                  <div class="invalid-field" *ngIf="reviewDtlForm.controls['lastName'].errors?.pattern">
                    <span>Last Name is invalid.</span>
                  </div>
                  <div
                    class="invalid-field"
                    *ngIf="reviewDtlForm.controls['lastName'].touched && reviewDtlForm.controls['lastName'].errors?.required"
                  >
                    <span>Last name required</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-xs-12 PL-15 PR-15">
                <div class="form-group required">
                  <label class="review-label control-label">Email</label>
                  <input
                    class="form-control"
                    maxlength="50"
                    placeholder="Enter email address"
                    formControlName="email"
                    type="text"
                    name="email"
                    required
                  />
                  <div class="invalid-field" *ngIf="reviewDtlForm.controls['email'].errors?.pattern">
                    <span>Please enter a valid email.</span>
                  </div>
                  <div class="invalid-field" *ngIf="reviewDtlForm.controls['email'].touched && reviewDtlForm.controls['email'].errors?.required">
                    <span>Email required</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-xs-4 PL-15 PR-15">
              <div class="form-group">
                <label class="review-label">Rating</label>
                <div id="full-stars" class="PD-6" style="padding: 3px">
                  <div class="rating-group">
                    <ng-container *ngFor="let i of numbers">
                      <label (mouseover)="onMouseover(i)" (mouseout)="onMouseout()" class="rating__label" for="rating-{{ i }}"
                        ><i
                          class="rating__icon rating__icon--star fa"
                          [ngClass]="{ 'fa-star': i <= reviewDtlForm.value.rating, 'fa-star-o': i > reviewDtlForm.value.rating }"
                        ></i
                      ></label>
                      <input
                        class="rating__input"
                        name="rating"
                        id="rating-{{ i }}"
                        value="{{ i }}"
                        type="radio"
                        formControlName="rating"
                        (click)="ratingSelect(i)"
                      />
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-8 col-xs-12 PL-15 PR-15">
              <div class="form-group">
                <label class="review-label">Title</label>
                <input
                  class="form-control"
                  maxlength="100"
                  placeholder="Write title here..."
                  formControlName="title"
                  type="text"
                  (change)="trimSpaceFromBothEnd()"
                />
              </div>
              <small
                id="titleHelp"
                class="form-text text-danger"
                *ngIf="reviewDtlForm.controls['title'].invalid && (reviewDtlForm.controls['title'].dirty || reviewDtlForm.controls['title'].touched)"
              >
                <span *ngIf="reviewDtlForm.controls['title'].errors?.required">Please enter Title</span>
                <!-- <span *ngIf="reviewDtlForm.controls['title'].errors?.pattern">Title is invalid.</span> -->
              </small>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-xs-12 PL-15 PR-15">
              <div class="form-group">
                <label class="review-label">Review</label>

                <textarea
                  class="form-control textarea-description"
                  maxlength="250"
                  formControlName="description"
                  placeholder="Write review here..."
                  type="text"
                  (change)="trimSpaceFromBothEnd()"
                ></textarea>
                <span class="pull-right char-left"
                  ><em>{{ 250 - reviewDtlForm.value.description.length }} characters left</em></span
                >
              </div>
              <small
                id="descriptionHelp"
                class="form-text text-danger"
                *ngIf="
                  reviewDtlForm.controls['description'].invalid &&
                  (reviewDtlForm.controls['description'].dirty || reviewDtlForm.controls['description'].touched)
                "
              >
                <span *ngIf="reviewDtlForm.controls['description'].errors?.required">Please enter Review</span>
                <!-- <span *ngIf="reviewDtlForm.controls['description'].errors?.pattern">Review is invalid.</span> -->
              </small>
            </div>
          </div>
          <div class="row" *ngIf="!userDetails">
            <div class="col-sm-12 col-xs-12 PL-15 PR-15">
              <p class="mandatory-field-lable">All fields marked with * are required</p>
            </div>
          </div>
          <div class="row displayDeskTop">
            <div class="col-sm-12 col-xs-12 PL-15 PR-15">
              <div class="form-group">
                <div id="captcha" class="captcha"></div>
              </div>
            </div>
          </div>
          <div class="row displayPopUp">
            <div class="col-sm-12 col-xs-12 PL-15 PR-15">
              <div class="form-group">
                <div id="captchaMob" class="captchaMob"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer mobile-footer">
          <button (click)="modalClose()" class="btn print-btn text-uppercase pull-left mobile-btn">Cancel</button>
          <button
            type="submit"
            [ngClass]="{ 'disable-cls': reviewDtlForm.invalid }"
            (click)="createReview()"
            class="btn submit-btn app-btn mt-0 text-uppercase pull-right mobile-btn"
          >
            Submit
          </button>
          <div class="clearfix"></div>
        </div>
      </form>
    </article>
  </section>
</div>

<div [ngClass]="{ loading: showLoader }"></div>
